import type { NavigateFunction } from "react-router-dom";

import { playPairFailureSound } from "@/lib/floorStationPairAudio";

export function playFailureSoundAndNavigate(
  navigate: NavigateFunction,
  to: string,
  options: { replace?: boolean } = {},
): void {
  playPairFailureSound();
  navigate(to, { replace: options.replace ?? false });
}

export function flashAndBumpToOverview(input: {
  navigate: NavigateFunction;
  to: string;
  storageKey: string;
  message: string;
  replace?: boolean;
}): void {
  try {
    sessionStorage.setItem(input.storageKey, input.message);
  } catch {
    /* private mode or storage quota */
  }
  playPairFailureSound();
  input.navigate(input.to, { replace: input.replace ?? true });
}

